// extracted by mini-css-extract-plugin
export default {"ContectSelect":"ContectUs_ContectSelect__Bk-Jq"};